import type { Theme } from "@emotion/react";

export type StatusTone = "success" | "warning" | "error" | "neutral";

// responseCode is the subscriber's raw HTTP status, distinct from `status`
// (radar's own succeeded/pending/failed outcome) - null means no response was
// ever received (e.g. connection failure or timeout), not a failing code.
export const responseCodeTone = (code: number | null): StatusTone => {
  if (code === null) return "neutral";
  return code >= 200 && code < 400 ? "success" : "error";
};

export const getToneColors = (tone: StatusTone, theme: Theme) => {
  switch (tone) {
    case "success":
      return {
        color: theme.colors.success,
        backgroundColor: `${theme.colors.success}33`,
      };
    case "warning":
      return {
        color: theme.colors.warning,
        backgroundColor: `${theme.colors.warning}33`,
      };
    case "error":
      return {
        color: theme.colors.error,
        backgroundColor: `${theme.colors.error}33`,
      };
    case "neutral":
      return {
        color: theme.text.colors.secondary,
        backgroundColor: `${theme.text.colors.secondary}33`,
      };
  }
};
